import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SelectedTeamEditor from 'components/personnel/SelectedTeamEditor';

import { collectData } from 'components/helpers/reactQuery';

export default function SelectedTeamsList({
  currentPersonnel,
  domainTeams,
  isTeamManagerAssignable,
  onTeamSelectionDelete,
  onTeamSelectionRoleChange,
}) {
  const queryClient = useQueryClient();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.SelectedTeamsList',
  });

  const collectedAssignableTeams = collectData({
    queryClient,
    queryKey: ['assignableTeams'],
  });

  const currentTeams = currentPersonnel.teamSelections
    .map((team) => {
      const selectedTeam =
        team.persisted ?
          domainTeams[team.id]
        : collectedAssignableTeams.find(
            (assignableTeamData) => assignableTeamData.id === team.id,
          );

      if (!selectedTeam) return null;

      let tooltip;
      if (!isTeamManagerAssignable) {
        tooltip = i18nT('tooltip.noUser', {
          firstName: currentPersonnel.firstName,
          interpolation: { escapeValue: false },
        });
      }

      return {
        ...team,
        id: team.id,
        name: selectedTeam.attributes.name,
        isManager: team.isManager,
        isStatusChangeEnabled: isTeamManagerAssignable,
        tooltip,
      };
    })
    .filter(Boolean);

  return (
    <div className='form-container'>
      {currentTeams.map((team) => (
        <div
          className='tw-group/pill chip-item-pill w-100 py-6 px-12 m-b-8 tw-relative tw-flex tw-h-10 tw-items-center tw-justify-between tw-rounded-md tw-bg-grey-050'
          key={team.id}
        >
          <div className='tw-w-52 tw-text-s tw-font-medium tw-tracking-wide'>
            {team.name}
          </div>
          <div className='tw-flex tw-items-center'>
            <SelectedTeamEditor
              onChange={onTeamSelectionRoleChange}
              teamSelection={team}
            />
            <span
              className="collection-select__multivalue-remove m-l-8 circle--remove tw-bg-transparent before:tw-bg-grey-700 before:tw-content-[''] after:tw-bg-grey-700 after:tw-content-[''] hover:tw-bg-red-600 hover:before:tw-bg-white hover:after:tw-bg-white"
              onClick={() => onTeamSelectionDelete(team.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

SelectedTeamsList.propTypes = {
  currentPersonnel: PropTypes.object.isRequired,
  domainTeams: PropTypes.object,
  isTeamManagerAssignable: PropTypes.bool,
  onTeamSelectionDelete: PropTypes.func.isRequired,
  onTeamSelectionRoleChange: PropTypes.func.isRequired,
};
